import { call, put, all, spawn, takeEvery } from 'redux-saga/effects';
import request from 'utils/request';
import { showToast } from 'containers/Toast/actions';
import {
  ADD_MONEY_TO_FEE_WALLET_URL,
  ADD_MONEY_TO_WALLET,
  CREATE_DISPUTE_WALLET_URL,
  CREATE_WALLET,
  CREATE_WALLET_URL,
  DISPUTE_WALLET,
  FEE_WALLET,
  GET_DISPUTE_WALLET_BALANCE_URL,
  GET_DISPUTE_WALLET_STATUS_URL,
  GET_FEE_WALLET_STATUS_URL,
  GET_WALLET_BALANCE,
  GET_WALLET_BALANCE_URL,
  GET_WALLET_STATUS,
  MODIFY_WALLET_STATUS,
  MODIFY_WALLET_STATUS_URL,
  REFUND_WALLET,
  UPDATE_DISPUTE_WALLET_URL,
} from './constants';
import {
  disableLoaderAction,
  updateBankDetailsAction,
  updateDisputeWalletsAction,
  updateDisputeWalletsBankDetailsAction,
  updateFeeWalletDetailsAction,
  updateWalletBalanceAction,
  updateWalletStatusAction,
} from './actions';

import { GET_WALLET_STATUS_URL, ADD_MONEY_TO_WALLET_URL, ADD_MONEY_TO_DISPUTE_WALLET_URL, } from '../../constants/url';

export function* getWalletStatus({ data }: any) {
  try {
    const { walletType, cb } = data;
    let {url, method} = GET_WALLET_STATUS_URL;
    switch (walletType) {
      case FEE_WALLET:
          url = GET_FEE_WALLET_STATUS_URL.url;
          method = GET_WALLET_STATUS_URL.method;
        break;
      case DISPUTE_WALLET:
          url = GET_DISPUTE_WALLET_STATUS_URL.url;
          method = GET_DISPUTE_WALLET_STATUS_URL.method;
        break;
      default:
        break;
    }
    const response = yield call(request, url, { method });
    if (walletType === REFUND_WALLET) yield put(updateWalletStatusAction(response));
    else if(walletType === DISPUTE_WALLET){
      yield put(updateDisputeWalletsAction(response));
    }
    else {
      const { status, balance } = response;
      yield put(updateFeeWalletDetailsAction({ status, balance }))
    }
    if (cb) cb(response);
  } catch (err) {
    // this is a hacky solution, will remove once backend is also resolved
    const metaData = err.errorMeta || {};
    yield put(disableLoaderAction());
    if (
      !metaData?.message?.toUpperCase().includes('NOT FOUND')
    )
      yield put(showToast(err));
  }
}

export function* getWalletBalance({ data }: any) {
  try {
    const { cb,walletType } = data;
    let { url, method } = GET_WALLET_BALANCE_URL;
    if(walletType === DISPUTE_WALLET){
      url = GET_DISPUTE_WALLET_BALANCE_URL.url;
      method = GET_DISPUTE_WALLET_BALANCE_URL.method;      
    }
    const response = yield call(request, url, { method });
    yield put(updateWalletBalanceAction({...response,walletType}));
    if (cb) cb();
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* addMoneyToWallet({ data }: any) {
  try {
    const { walletType } = data;
    let {url,method} = ADD_MONEY_TO_WALLET_URL;
    switch (walletType) {
      case 'Fee Wallet':
        url = ADD_MONEY_TO_FEE_WALLET_URL.url;
        method = ADD_MONEY_TO_FEE_WALLET_URL.method;
        break;
      case 'Dispute Wallet':
        url = ADD_MONEY_TO_DISPUTE_WALLET_URL.url;
        method = ADD_MONEY_TO_DISPUTE_WALLET_URL.method;
        break;
      default:
        break;
    }
    // const { url, method } = walletType === FEE_WALLET ? ADD_MONEY_TO_FEE_WALLET_URL : ADD_MONEY_TO_WALLET_URL;
    const options = {
      method,
    };
    const response = yield call(request, url, options);
    const { vba, ifsc } = response;
    if(walletType==='Refund Wallet'){yield put(updateBankDetailsAction({ vba, ifsc }))}else{
      yield put(updateDisputeWalletsBankDetailsAction({vba, ifsc}))
    };
    yield put(disableLoaderAction());
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* createWallet({ data }: any) {
  try {
    const { refId, name, createdBy, cb, type } = data;
    const { url, method }  = name === 'REFUND'?CREATE_WALLET_URL:CREATE_DISPUTE_WALLET_URL;
    const options = {
      method,
      body: JSON.stringify({ refId, name, createdBy, type }),
    };
    const response = yield call(request, url, options);
    const { vba, ifsc } = response.rechargeMode;
    yield put(updateBankDetailsAction({ vba, ifsc }));
    if (cb) cb(response);
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* modifyWalletStatus({ data }: any) {
  try {
    const { updatedBy, name, status } = data;
    const { url, method } = name===DISPUTE_WALLET ? UPDATE_DISPUTE_WALLET_URL:MODIFY_WALLET_STATUS_URL;
    const options = {
      method,
      body: JSON.stringify({ name, status, updatedBy }),
    };
    yield call(request, url, options);
    yield put(disableLoaderAction());
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* getWalletStatusSaga() {
  yield takeEvery(GET_WALLET_STATUS, getWalletStatus);
}

export function* getWalletBalanceSaga() {
  yield takeEvery(GET_WALLET_BALANCE, getWalletBalance);
}

export function* addMoneyToWalletSaga() {
  yield takeEvery(ADD_MONEY_TO_WALLET, addMoneyToWallet);
}

export function* modifyWalletStatusSaga() {
  yield takeEvery(MODIFY_WALLET_STATUS, modifyWalletStatus);
}

export function* createWalletSaga() {
  yield takeEvery(CREATE_WALLET, createWallet);
}

// Individual exports for testing
export default function* walletsSaga() {
  // See example in containers/HomePage/saga.js
  const sagas = [
    getWalletStatusSaga,
    getWalletBalanceSaga,
    addMoneyToWalletSaga,
    modifyWalletStatusSaga,
    createWalletSaga,
  ];

  yield all(
    sagas.map(saga =>
      // eslint-disable-next-line func-names, prettier/prettier
      spawn(function* () {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            // eslint-disable-next-line no-console
            console.log(e);
          }
        }
      }),
    ),
  );
}
